import { Typography, useTheme } from '@mui/material'
import { components } from 'react-select'

const GroupHeading = props => {
  const theme = useTheme();

  return (
    <components.GroupHeading {...props}>
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 500,
          color: theme.palette.grey[700],
          padding: '4px 0',
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
        }}
      >
        {props.data.label}
      </Typography>
    </components.GroupHeading>
  );
};

export default GroupHeading;